var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 32,
    fill: "black",
    id: "svg_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m18,0l-18,0l0,18l18,0l0,-18zm-11.10775,4.2191c0.79621,-0.3257 1.49744,-0.7852 2.08834,-1.34172c0.58601,0.56172 1.28321,1.02722 2.07651,1.35982c0.7933,0.3327 1.6141,0.5037 2.4254,0.528c0.0172,0.8115 0.181,1.6337 0.5068,2.4299c0.3257,0.7962 0.7851,1.4975 1.3417,2.0884c-0.5617,0.586 -1.0272,1.2832 -1.3599,2.0765c-0.3327,0.7933 -0.5037,1.614 -0.5279,2.4254c-0.8116,0.0172 -1.6337,0.181 -2.4299,0.5067c-0.7963,0.3258 -1.49747,0.7852 -2.08837,1.3418c-0.58603,-0.5617 -1.28321,-1.0273 -2.07656,-1.3599c-0.79334,-0.3327 -1.61405,-0.5037 -2.42542,-0.528c-0.01721,-0.8116 -0.18102,-1.6337 -0.50676,-2.43c-0.32573,-0.7961 -0.78513,-1.4973 -1.34165,-2.0882c0.56167,-0.5861 1.02718,-1.2832 1.35985,-2.0766c0.33268,-0.7933 0.50365,-1.614 0.52794,-2.4253c0.81155,-0.0173 1.63371,-0.1811 2.42992,-0.5068z",
    fill: "white",
    id: "svg_14"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e8529209b91f3a0766efeec466cda1f6.svg";
export { ForwardRef as ReactComponent };